import { Theme } from "src/app/interfaces/theme.model";
const lonaniDefaults = { promoImg: "url(assets/images/promo_3.png)" };

export const LonaniTheme: Theme = {
  name: "lonani",
  useGateway: true,
  showTcktVerification: true,

  properties: {
    //-------------------------  header-----------------------------
    "--app-background-header": "#fff",
    "--app-background-base": "#fff",
    "--app-background-body": "#009d48",
    "--app-background-turf-home": "#f2f2f2",
    "--app-background-footer": "#037b3a",
    "--app-background-left-menu": "#037b3a",
    "--app-background-right-menu": "",
    "--app-background-nav": "#149449",
    "--app-background-nav-hover": "#009d48",
    "--app-background-nav-border-bottom": "#fa7f22",
    "--app-background-main": "rgb(242, 242, 242)",
    "--app-background-home": "#037b3a",
    "--app-color-tournament": "#154e2b",
    "--app-color-heading": "#77777a",
    "--app-color-header": "#77777a",
    "--app-color-body": "#5d5d5d",
    "--app-color-footer": "#eb862c",
    "--app-color-nav": "#fff",
    "--app-color-main": "#212121",
    "--app-color-forgot_pw": "#149449",
    "--app-background-primary-tint": "",
    "--app-background-input-primary": "#dedede",
    "--app-background-secondary-tint": "#149449",

    //-------------------------  owl calendar-----------------------------
    "--app-background-calendar-header": "#fa7f22",
    //-------------------------  side menu-----------------------------
    "--app-background-side-menu": "#e6e6e6",
    "--app-color-side-menu": "#fff",
    // lexique
    // "--app-color-lexique": "#403939",
    // "--app-background-lexique": "#F9A90E",
    "--app-color-lexique": "#fff",
    "--app-background-lexique": "#fa7f22",
    "--app-background-cmtJr": "#fa7f22",
    "--app-color-cmtJr": "#fff",

    // promotions
    "--app-color-promotions": "#fff",
    "--app-background-promotions": "#149449",
    "--app-background-border-promotions": "#fa7f22",

    // cagnottes
    "--app-color-cagnotte-header": "#fff",
    "--app-background-cagnotte-header": "#fa7f22",
    // comment jouer
    //-------------------------  second nav-----------------------------
    "--app-background-second-nav": "#fa7f22",
    "--app-background-second-nav-hover": "#009d48",
    "--app-color-second-nav": "#fff",
    "--app-background-second-nav-selected": "#fff",
    "--app-color-second-nav-selected": "#149449",
    "--app-background-border-second-nav-selected": "#fa7f22",
    "--app-color-second-nav-course": "#77777a",

    //-------------------------  rapports-----------------------------
    "--app-color-rapport": "#77777a",
    "--app-background-rapport": "#009d48",
    "--app-background-rapport-header-border": "#149449",

    //-------------------------  top races-----------------------------
    "--app-color-top-race-RN": "#149449",
    "--app-color-top-race-CN": "#149449",
    "--app-color-top-race-time": "#b9b8ba",
    "--app-color-top-race-time-up": "#F9A90E",
    "--app-background-top-race": "#e6e6e6",
    //-------------------------  meetings-----------------------------
    "--app-color-meeting-link": "#77777a",
    "--app-background-meeting-link": "#fff",
    "--app-color-meeting-link-selected": "#fff",
    "--app-background-meeting-link-selected": "#149449",
    "--app-background-meeting-link-borders": "#149449",

    //-------------------------  race details-----------------------------
    "--app-color-race-time": "#77777a",
    //-------------------------  race list-----------------------------
    "--app-color-table-header": "#77777a",
    "--app-color-table-header-border-left": "#149449",
    "--app-background-wrap-race": "#fff",
    "--app-color-table-headings": "",
    "--app-color-table": "#77777a",
    "--app-color-table-subdetails": "#77777a",
    "--app-color-table-numbers": "#77777a",
    "--app-color-table-open": "#fff",
    "--app-color-table-content-open": "#77777a",
    "--app-background-table-open": "#5d5d5d",
    //-------------------------  registration-----------------------------
    "--app-color-registration": "#fff",
    "--app-background-registration": "#149449",
    "--app-background-registration-input": "#dedede",
    "--app-color-registration-input": "#000",
    "--app-background-registration-input-border": "#fff",
    "--app-color-registration-validation-error": "#F9A90E",

    //-------------------------  footer-----------------------------
    "--app-color-footer-heading-1": "#00ff75",
    "--app-color-footer-body": "",
    // reset password
    "--app-color-resetpw-header": "#149449",
    //-------------------------  transactions history and account -----------------------------
    "--app-background-transactions": "#009d48",
    "--app-background-profile-body": "#149449",
    "--app-color-transaction-tab-secondary": "#f8bd31",
    "--app-color-transaction-tab-primary": "#fff",
    "--app-color-profile-section-activeheader": "#f8bd31",
    "--app-background-profile-header": "#149449",
    "--app-background-profile-header-border": "#009d48",
    "--app-background-profile-section-header": "#176334",
    "--app-color-profile-section-header": "#fff",
    "--app-color-profile-input": "#fff",
    "--app-color-profile-input-placeholder": "#eee",
    "--app-background-profile-input": "#149449",
    "--app-color-profile-input-border": "#176334",
    "--app-color-profile-input-lable": "#64c388",
    "--app-background-transactions-body": "#149449",
    "--app-color-transactions-header": "#64c388",
    "--app-color-transactions-header-input-border": "#64c388",
    "--app-color-transactions-header-input-lable": "#64c388",
    "--app-color-transactions-header-input": "#fff",

    "--app-background-transactions-tabs": "#149449",
    "--app-color-accounts": "#dedede",
    "--app-background-row-even": "#fff",
    "--app-background-row-odd": "#dedede",
    "--app-color-transactions-container-color": "#154e2b",
    "--app-background-transaction-methods": "#009d48",
    "--app-background-active-trans-method":
      "linear-gradient(90deg  , #F9A90E -1.5%, #009d48 101.5%)",
    "--app-color-methods-border-left": "#009d48",
    "--app-color-border-acc-input-focus": "#009d48",

    //-------------------------  betslip-----------------------------
    "--app-color-betslip-header": "#fff",
    "--app-background-betslip-header": "#149449",
    "--app-background-betSummary": "#F9A90E",
    "--app-color-betSummary": "#403939",
    "--app-color-yello-odd": "#F9A90E",
    "--app-color-background-dropdown": "#149449",
    "--app-color-betslip": "#149449",
    "--app-background-betslip": "#fff",
    "--app-color-betslip-amount": "#037b3a",
    "--app-color-betslip-meeting": "#777777",
    //-------------------------  betslip-----------------------------
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",

    "--app-background-checkbox-input": "#F9A90E",
    "--app-color-checkbox-input-border": "#fff",
    //-------------------------  account modal -----------------------------

    "--app-background-modal-window": "#149449",
    "--app-color-modal-window": "#fff",

    //-------------------------  buttons-----------------------------
    "--app-color-button-primary": "#fff",
    "--app-background-button-primary": "#149449",
    "--app-color-button-secondary": "#fff",
    "--app-background-button-secondary": "#fa7f22",
    "--app-color-bet-button": "#5d5d5d",
    "--app-background-bet-button": "#F9A90E",
    "--app-color-rapport-button": "#77777a",
    "--app-background-rapport-button-border": "#b9b8ba",
    "--app-background-rapport-button": "#fff",
    "--app-color-betSlip-button": "#fff",
    "--app-background-betSlip-button": "#b9b8ba",
    "--app-color-coef-button": "#fff",
    "--app-background-coef-button": "#F9A90E",
    //-------------------------  Account Modal-----------------------------
    "--app-background-main-modal": "#149449",
    "--app-color-main-modal": "#efd7c2",
    "--app-color-main-modal-border": "#009d48",

    // -----------------------------faq -----------------------------------
    "--app-color-faq-header": "#009d48",

    // -----------------------------default imgs --------------------------
    "--img-default-promo": lonaniDefaults.promoImg,
  },
  partnerID:"PMU",
  country: "NE",
  contact:{
    tel: '+227 96 98 32 30',
    email: 'lonani@lonanionline.ne',
    fax: '+227 20 73 69 11',
    addresse: 'e'
  },
    betOptions: {
    version: '4.3'
  },
  nationalOptions: {
    indicesA: [1,2,3,4],
    indicesP: [],
    tarifsExtension: ['.jpg', '.jpg']
  }
};